// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__qd4bM","active":"NavigationItem_active__2qolM"};